import React from 'react';
import {Container} from '@material-ui/core';

import Banner from '../global/Banner';
import {privacy} from '../../values';
import {useStyles} from '../global/styles';
const Privacy = () => {
    const classes = useStyles()
    return (
        <div>
            <Banner title={privacy.title} />
            <div className={classes.containerPrivacy}>
                <div style={{height:100}} />
                <Container maxWidth="lg">
                    <p style={{color:'white', margin:0, textAlign:'justify', fontFamily:'Book',}}>
                        Con fundamento en los artículos 15 y 16 de la Ley Federal de Protección de Datos Personales en Posesión de Particulares hacemos conocimiento que Rayas con domicilio en Av Paseo del Origen #600 Col Bosques de Aanta Anita Tlajomulco de Zúñiga, Jalisco, México es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección. Su información personal será utilizada para las siguientes finalidades: proveer los servicios y productos que ha solicitado; notificarle sobre nuevos productos y servicios que tengan relación con los ya contratados o adquiridos; comunicarle sobre cambios en los mismos; elaborar estudios y programas que son necesarios para determinar hábitos de consumo; realizar evaluaciones periódicas de nuestros productos y servicios a efecto de mejorar la calidad de los mismos; evaluar la calidad del servicio que brindamos, y en general, para dar cumplimiento a las obligaciones que hemos contraído con usted. 
                    </p>
                    <br/>
                    <p style={{color:'white', margin:0, textAlign:'justify', fontFamily:'Book',}}>
                        Para las finalidades antes mencionadas, requerimos obtener los siguientes datos personales:  
                    </p>
                    <p style={{color:'white', margin:0, textAlign:'justify', fontFamily:'Book',}}>
                        Nombre completo, edad, sexo, teléfono fijo, correo electrónico, dirección. 
                    </p>
                    <p style={{color:'white', margin:0, textAlign:'justify', fontFamily:'Book',}}>
                        Es importante informarle que usted tiene derecho al acceso, rectificación y cancelación de sus datos personales a oponerse al tratamiento de los mismos o a revocar el consentimiento que para dicho fin nos haya otorgado. 
                    </p>
                    <br/>
                    <p style={{color:'white', margin:0, textAlign:'justify', fontFamily:'Book',}}>
                        Para ello es necesario que envíe la solicitud en los términos que marca la Ley en su Art.29 a Carmen Rayas, responsable de nuestro Departamento de Protección de Datos Personales. Ubicado en Av Paseo del Origen #600 Col Bosques de Aanta Anita Tlajomulco de Zúñiga, Jalisco, México, o bien, se comunique al teléfono 3327931096 o por correo electrónico a lourdesarceorayas@gmail.com.
                    </p>
                    <br/>
                    <p style={{color:'white', margin:0, textAlign:'justify', fontFamily:'Book',}}>
                        En caso de que no desee recibir mensajes promocionales de nuestra parte, puede enviarnos su solicitud por medio de la dirección electrónica puesta arriba.
                    </p>
                </Container>
                <div style={{height:150}} />
            </div>
        </div>
    );
};

export default Privacy;